import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCity } from '@src/containers/Session/selectors/getCity';
import { ROUTE_PATHS } from '@src/containers/Session/constants';
import getRouterCtx from '@src/containers/Session/selectors/getRouterCtx';
import { getSFULinks } from '@src/containers/Session/selectors/getSFULinks';

import LinkLines from '..';

const LinkLinesCCatalog = (props) => {
	const { ...rest } = props;
	const city = useSelector(getCity);
	const routeData = useSelector(getRouterCtx);
	const sfuLinks = useSelector(getSFULinks);

	const groups = useMemo(() => {
		const baseHref = ROUTE_PATHS.LISTING.replace('[town]', city?.domain);
		return (sfuLinks?.sfuGroups || []).map((g) => {
			const currUrl = routeData.resolvedUrl;
			return {
				id: g.id,
				title: g.title,
				lines: (g.sfus || [])
					.filter((sfu) => {
						const targetUrl = `${baseHref}${sfu.slug}/`;
						return targetUrl !== currUrl;
					})
					.map((sfu) => {
						const targetUrl = `${baseHref}${sfu.slug}/`;
						return {
							id: sfu.id,
							label: sfu.label,
							href: targetUrl,
						};
					}),
			};
		});
	}, [city?.domain, routeData.resolvedUrl, sfuLinks]);

	const title = sfuLinks?.title;

	return <LinkLines groups={groups} title={title} {...rest} />;
};

LinkLinesCCatalog.propTypes = {
	...LinkLines.propTypes,
};

export default LinkLinesCCatalog;
